"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportMenu = void 0;
const react_1 = __importStar(require("react"));
const colors_1 = require("../../../theme/colors");
const icons_1 = require("../../../theme/icons");
const buttons_1 = require("../../buttons");
const forms_1 = require("../../forms");
const RadioButton_1 = require("../../forms/RadioButton");
const global_1 = require("../../global");
const PrintOption_1 = __importDefault(require("../PrintOption/PrintOption"));
const ExportMenu_styles_1 = require("./ExportMenu.styles");
const ExportMenu = ({ header, exportData, selectedOption, setSelectedOption, onPrimaryButtonClick, onSecondaryButtonClick, setPrintOptionSelectValue, primaryButtonLabel, secondaryButtonLabel, }) => {
    const [open, setOpen] = (0, react_1.useState)(true);
    return (react_1.default.createElement(ExportMenu_styles_1.Wrapper, { open: open },
        react_1.default.createElement(ExportMenu_styles_1.Content, null,
            react_1.default.createElement(ExportMenu_styles_1.HeaderContainer, null,
                react_1.default.createElement(ExportMenu_styles_1.Header, null, header),
                react_1.default.createElement(global_1.IconWrapper, { onClick: () => setOpen(false) },
                    react_1.default.createElement(icons_1.Close, null))),
            react_1.default.createElement(ExportMenu_styles_1.OptionList, null, exportData.map((data) => (react_1.default.createElement(ExportMenu_styles_1.OptionContainer, { key: data.optionName },
                react_1.default.createElement(ExportMenu_styles_1.OptionHeader, null,
                    react_1.default.createElement(RadioButton_1.RadioButton, { checked: selectedOption === data.optionName, label: data.label, onChange: () => setSelectedOption(data.optionName) }),
                    react_1.default.createElement(ExportMenu_styles_1.PDFIconWrapper, { "$active": selectedOption === data.optionName },
                        react_1.default.createElement(data.icon, null))),
                react_1.default.createElement(PrintOption_1.default, { setPrintOptionSelectValue: setPrintOptionSelectValue, active: selectedOption === data.optionName, description: data.description, printOptions: data.printOptions }),
                react_1.default.createElement(ExportMenu_styles_1.Divider, null))))),
            react_1.default.createElement(ExportMenu_styles_1.ButtonList, null,
                react_1.default.createElement(forms_1.IconButton, { label: primaryButtonLabel, onClick: onPrimaryButtonClick, disabled: false, loading: undefined, className: undefined, isRUD: undefined },
                    react_1.default.createElement(icons_1.Download, { color: colors_1.WHITE })),
                react_1.default.createElement(ExportMenu_styles_1.CancelButtonWrapper, null,
                    react_1.default.createElement(buttons_1.Button, { label: secondaryButtonLabel, onClick: onSecondaryButtonClick }))))));
};
exports.ExportMenu = ExportMenu;
exports.default = exports.ExportMenu;
//# sourceMappingURL=ExportMenu.js.map